import { Stack, Typography } from '@sureco/design-system'
import React from 'react'
import { ContributionFile } from '../types/get-contribution-response.dto'
import { convertToLocalFromUTCISODate } from 'helpers/datetime'
import { DEFAULT_BENCHMARK_LABEL } from '../utils'
import { BenchmarkSnapshot } from '../types/types'

interface CurrentActiveModelProps {
  activeModel?: ContributionFile
  benchmarkSnapshot?: BenchmarkSnapshot
}

export default function CurrentActiveModel({
  activeModel,
  benchmarkSnapshot,
}: CurrentActiveModelProps) {
  return (
    <>
      <div
        style={{
          border: '1px solid #d9d9d9',
          borderRadius: 8,
          padding: '24px',
          backgroundColor: '#fff',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
          height: '100%',
        }}
      >
        {activeModel && (
          <Stack space={20}>
            {/* Header Section */}
            <Stack direction="col" align="center" justify="space-between">
              <Stack
                direction="row"
                align="center"
                space={8}
                style={{ marginBottom: 8 }}
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#52c41a',
                  }}
                />
                <Typography color="#003146" size={16} bold>
                  Active Model
                </Typography>
              </Stack>

              {/* Info Grid Section */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: 100,
                }}
              >
                <Stack space={8}>
                  <Typography color="#8c8c8c">Model Name</Typography>
                  {`${activeModel.filename} - ${convertToLocalFromUTCISODate(activeModel.uploadedAt)}`}
                </Stack>

                <Stack space={8}>
                  <Typography color="#8c8c8c">Benchmark Snapshot</Typography>
                  {benchmarkSnapshot?.title || DEFAULT_BENCHMARK_LABEL}
                </Stack>
              </div>
            </Stack>
          </Stack>
        )}

        {!activeModel && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <Typography
              color="rgba(0, 0, 0, 0.45)"
              style={{ opacity: 0.5 }}
              size={16}
              bold
            >
              No Active Model
            </Typography>
          </div>
        )}
      </div>
    </>
  )
}
